import { i18n } from '@lingui/core';
import React from 'react';

const RESULTS_SKIPLINK_ID = 'skip-to-results';

type ResultsSkipLinkProps = {
    inline?: boolean;
};

export function ResultsSkipLink(props: ResultsSkipLinkProps) {
    const { inline = false } = props;

    const linkClass = `skiplink ${inline ? 'skiplink--inline' : ''}`;

    return (
        <a className={linkClass} href={`#${RESULTS_SKIPLINK_ID}`}>
            {i18n.t({
                id: 'skiplink.skip-to-results',
                message: 'Skip to results',
            })}
        </a>
    );
}

export function ResultsSkipLinkTarget() {
    return <div className="skiplink-target" id={RESULTS_SKIPLINK_ID}></div>;
}
